// EditableField.js - Simplified version with correct ID handling
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useGlobalContext } from '../hooks/useGlobalContext';

const EditableField = (props) => {
  const { cellData, onItemizedItemEdit, itemId } = props;
  const { theme } = useGlobalContext();

  return (
    <InputGroup className="my-1 flex-nowrap">
      {cellData.leading != null && (
        <InputGroup.Text
          className={`fw-bold border-0 px-2 ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-secondary'}`}
        >
          <span className="border border-2 border-secondary rounded-circle d-flex align-items-center justify-content-center small" style={{width: '20px', height: '20px'}}>
            {cellData.leading}
          </span>
        </InputGroup.Text>
      )}
      <Form.Control
        className={cellData.textAlign}
        type={cellData.type}
        placeholder={cellData.placeholder}
        min={cellData.min}
        name={cellData.name}
        id={cellData.id}
        value={cellData.value}
        step={cellData.step}
        precision={cellData.precision}
        aria-label={cellData.name}
        // Pass both event and itemId to the handler
        onChange={(e) => onItemizedItemEdit(e, itemId)}
        required
      />
    </InputGroup>
  );
};

export default EditableField;